import React, { ReactNode } from 'react'

import './index.css'
import 'bootstrap/dist/css/bootstrap.css'

import * as serviceWorker from './serviceWorker'
import { createRoot } from 'react-dom/client'
import AppWrapper from './AppWrapper'
import { Buffer } from 'buffer'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { GTMProvider } from '@elgorditosalsero/react-gtm-hook'
import { CookiesProvider } from 'react-cookie'

window.Buffer = window.Buffer || Buffer
const container = document.getElementById('root') as HTMLDivElement
const root = createRoot(container!)
const reCaptchaKey = process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY!
const gtmParams = {
  id: process.env.REACT_APP_GTM_ID!,
  environment: {
    gtm_auth: process.env.REACT_APP_GTM_AUTH!,
    gtm_preview: process.env.REACT_APP_GTM_PREVIEW!,
  },
}

const GTMWrapper: React.FC<{ children: ReactNode }> = ({ children }) => {
  return process.env.REACT_APP_GTM_ENABLED === 'true' ? <GTMProvider state={gtmParams}>{children}</GTMProvider> : <>{children}</>
}

root.render(
  <GTMWrapper>
    <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey} useEnterprise={true} container={{ element: 'google-ca', parameters: { theme: 'light' } }}>
      <CookiesProvider>
        <AppWrapper />
      </CookiesProvider>
    </GoogleReCaptchaProvider>
  </GTMWrapper>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
